import {
  FaBullseye,
  FaBoxes,
  FaBuilding,
  FaCalendarAlt,
  FaChartLine,
  FaClipboardCheck,
  FaCog,
  FaCubes,
  FaExchangeAlt,
  FaGift,
  FaHandHoldingUsd,
  FaMoneyBillWave,
  FaTags,
  FaSlidersH,
  FaTachometerAlt,
  FaUserCog,
  FaUserFriends,
  FaUsers,
  FaWallet,
} from 'react-icons/fa';

export const adminNavigationGroups = [
  {
    key: 'master-data',
    label: 'Core Data',
    icon: FaCubes,
    matchPaths: [
      '/modules',
      '/addmodule',
      '/editmodule',
      '/outlets',
      '/addoutlet',
      '/editoutlet',
      '/outlet-modules',
      '/add-outlet-module',
      '/edit-outlet-module',
    ],
    items: [
      { to: '/outlets', label: 'Outlets', icon: FaBuilding },
      { to: '/outlet-modules', label: 'Outlet Modules', icon: FaBuilding },
      { to: '/modules', label: 'Modules', icon: FaCubes },
    ],
  },
  {
    key: 'people-access',
    label: 'Team & Access',
    icon: FaUsers,
    matchPaths: [
      '/employees',
      '/add-employee',
      '/edit-employee',
      '/karyawanmodules',
      '/add-karyawan-module',
      '/edit-karyawan-module',
      '/defaultmodulekaryawan',
      '/add-default-karyawan-module',
      '/edit-default-karyawan-module',
    ],
    items: [
      { to: '/employees', label: 'Employees', icon: FaUsers },
      { to: '/karyawanmodules', label: 'Employee Modules', icon: FaUserCog },
      { to: '/defaultmodulekaryawan', label: 'Default Employee Modules', icon: FaUserCog },
    ],
  },
  {
    key: 'member-service',
    label: 'Clients & Programs',
    icon: FaUserFriends,
    matchPaths: [
      '/members',
      '/add-member',
      '/edit-member',
      '/membership-setting',
      '/add-membership',
      '/edit-membership',
      '/member-modules',
      '/add-member-module',
      '/edit-member-module',
      '/default-member-modules',
      '/add-default-member-module',
      '/edit-default-member-module',
      '/session-clients',
      '/fitness-transactions/setup',
      '/fitness-transactions/setup/pt-setting',
      '/pt-schedule-setting',
    ],
    items: [
      { to: '/members', label: 'Clients', icon: FaUserFriends },
      { to: '/session-clients', label: 'Clients Session', icon: FaUserFriends },
      { to: '/membership-setting', label: 'Plan Setup', icon: FaClipboardCheck, hideForKaryawan: true },
      { to: '/member-modules', label: 'Client Modules', icon: FaUserCog },
      { to: '/default-member-modules', label: 'Default Client Modules', icon: FaUserCog },
      { to: '/fitness-transactions/setup', label: 'Program Setup', icon: FaSlidersH, managementOnly: true },
      { to: '/pt-schedule-setting', label: 'Session Schedule', icon: FaCalendarAlt, hideForKaryawan: true },
    ],
  },
  {
    key: 'sales-collection',
    label: 'Sales & Payments',
    icon: FaHandHoldingUsd,
    matchPaths: [
      '/fitness-transactions',
      '/staff-shift-closing',
      '/membership-payment',
      '/add-membershippayment',
      '/deposits',
      '/deposit/edit',
      '/user-balance',
    ],
    items: [
      { to: '/fitness-transactions', label: 'Front Desk', icon: FaHandHoldingUsd, exact: true },
      { to: '/staff-shift-closing', label: 'Shift Closing', icon: FaClipboardCheck },
      { to: '/membership-payment', label: 'Client Plan Payments', icon: FaClipboardCheck, hideForKaryawan: true },
      { to: '/deposits', label: 'Client Deposits', icon: FaMoneyBillWave },
      { to: '/user-balance', label: 'Client Balance', icon: FaWallet },
    ],
  },
  {
    key: 'pos-management',
    label: 'Catalog & Inventory',
    icon: FaBoxes,
    matchPaths: [
      '/pos-categories',
      '/pos-products',
      '/pos-customers',
      '/pos-items',
      '/pos-laundry-methods',
      '/pos-laundry-times',
      '/pos-purchases',
      '/pos-pengajuan-pembatalan',
      '/pos-approval-pembatalan',
      '/pos-refund-void-approval',
      '/pos-stock-adjustments',
      '/pos-stock-opnames',
      '/pos-vendors',
      '/pos-account-mappings',
      '/pos-sync-monitor',
    ],
    items: [
      { to: '/pos-categories', label: 'Categories', icon: FaTags, managementOnly: true },
      { to: '/pos-products', label: 'Products & Services', icon: FaBoxes, managementOnly: true },
      { to: '/pos-customers', label: 'Customers', icon: FaUsers, managementOnly: true },
      { to: '/pos-items', label: 'Service Variants', icon: FaSlidersH, managementOnly: true },
      { to: '/pos-laundry-methods', label: 'Service Methods', icon: FaTags, managementOnly: true },
      { to: '/pos-laundry-times', label: 'Service Durations', icon: FaCalendarAlt, managementOnly: true },
      { to: '/pos-purchases', label: 'Purchases', icon: FaMoneyBillWave, managementOnly: true },
      { to: '/pos-pengajuan-pembatalan', label: 'Pengajuan Pembatalan', icon: FaExchangeAlt, managementOnly: true },
      { to: '/pos-approval-pembatalan', label: 'Approval Pembatalan', icon: FaClipboardCheck, managementOnly: true },
      { to: '/pos-stock-adjustments', label: 'Stock Adjustment', icon: FaClipboardCheck, managementOnly: true },
      { to: '/pos-stock-opnames', label: 'Stock Opname', icon: FaChartLine, managementOnly: true },
      { to: '/pos-vendors', label: 'Vendors', icon: FaBuilding, adminOnly: true },
      { to: '/pos-account-mappings', label: 'Account Mapping', icon: FaMoneyBillWave, managementOnly: true },
      { to: '/pos-sync-monitor', label: 'Sync Monitor', icon: FaExchangeAlt, adminOnly: true },
    ],
  },
  {
    key: 'finance-accounting',
    label: 'Finance & Accounting',
    icon: FaWallet,
    matchPaths: [
      '/accounting-setup',
      '/fitness-finance',
      '/operasional-finance',
      '/asset-management',
    ],
    items: [
      { to: '/accounting-setup', label: 'Accounting Control', icon: FaCog, adminOnly: true },
      { to: '/operasional-finance', label: 'Expenses & Payables', icon: FaMoneyBillWave, managementOnly: true },
      { to: '/asset-management', label: 'Assets & Investments', icon: FaBuilding, adminOnly: true },
    ],
  },
  {
    key: 'reports',
    label: 'Analytics & Reports',
    icon: FaChartLine,
    matchPaths: [
      '/report-center',
      '/staff-transaction-summary',
      '/member-activity-monitor',
      '/membership-daily-stats',
      '/membership-monthly-stats',
      '/reportcheckin',
    ],
    items: [
      { to: '/staff-transaction-summary', label: 'Staff Transaction Summary', icon: FaChartLine },
      { to: '/member-activity-monitor', label: 'Member Activity Monitor', icon: FaUserFriends },
      { to: '/reportcheckin', label: 'Check-in Report', icon: FaClipboardCheck },
      { to: '/report-center', label: 'Analytics Center', icon: FaChartLine },
    ],
  },
  {
    key: 'engagement',
    label: 'Engagement',
    icon: FaBullseye,
    matchPaths: ['/missions', '/addmission', '/editmission', '/rewards', '/addreward'],
    items: [
      { to: '/missions', label: 'Missions', icon: FaBullseye },
      { to: '/rewards', label: 'Rewards', icon: FaGift },
    ],
  },
];

export const adminDashboardLink = {
  to: '/dashboardadmin',
  label: 'Dashboard',
  icon: FaTachometerAlt,
  description: 'Overview backoffice',
};

export const adminNavigationSections = [
  {
    key: 'dashboard',
    title: 'Dashboard',
    items: [adminDashboardLink],
  },
  ...adminNavigationGroups.map(group => ({
    key: group.key,
    title: group.label,
    items: group.items,
  })),
];

export const getMatchedAdminGroupKey = pathname =>
  adminNavigationGroups.find(group =>
    group.matchPaths.some(path => pathname === path || pathname.startsWith(`${path}/`))
  )?.key || null;
